/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_water_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does exercise change the amount?`)
};

const es_water_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿El ejercicio cambia la cantidad?`)
};

const de_water_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verändert Training die Menge?`)
};

const nl_water_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verandert sport de hoeveelheid?`)
};

const fr_water_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'exercice change-t-il la quantité ?`)
};

const it_water_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'esercizio cambia la quantità?`)
};

const pt_br2_water_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O exercício muda essa quantidade?`)
};

const pt_water_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O exercício altera a quantidade?`)
};

const ja_water_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`運動によって量は変わりますか?`)
};

const zh_water_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运动会改变所需水量吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const water_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.water_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("water_faq_q2", locale)
	if (locale === "en") return en_water_faq_q2(inputs)
	if (locale === "es") return es_water_faq_q2(inputs)
	if (locale === "de") return de_water_faq_q2(inputs)
	if (locale === "nl") return nl_water_faq_q2(inputs)
	if (locale === "fr") return fr_water_faq_q2(inputs)
	if (locale === "it") return it_water_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_water_faq_q2(inputs)
	if (locale === "pt") return pt_water_faq_q2(inputs)
	if (locale === "ja") return ja_water_faq_q2(inputs)
	return zh_water_faq_q2(inputs)
};